export function initGallery() {
    var blocks = document.querySelectorAll('.gallery-block');

    blocks.forEach(function (block) {
        var triggers = Array.from(block.querySelectorAll('.gallery-block__trigger'));
        if (!triggers.length) return;

        var modalId = triggers[0].getAttribute('aria-controls');
        var modal = modalId ? document.getElementById(modalId) : null;
        if (!modal) return;

        var slides = Array.from(modal.querySelectorAll('.gallery-block__modal-slide'));
        var counter = modal.querySelector('.gallery-block__modal-counter');
        var prevBtn = modal.querySelector('.gallery-block__modal-prev');
        var nextBtn = modal.querySelector('.gallery-block__modal-next');
        var closeBtn = modal.querySelector('.gallery-block__modal-close');
        var current = 0;
        var total = slides.length;
        var activeTrigger = null;

        if (!total) return;

        var svgSeparator = '<svg xmlns="http://www.w3.org/2000/svg" width="21" height="6" fill="none" aria-hidden="true" focusable="false" viewBox="0 0 21 6"><use href="#gs-decoration-base"></use></svg>';

        function formatCounter(index) {
            var n = String(index + 1).padStart(2, '0');
            var t = String(total).padStart(2, '0');
            return '<span>' + n + '</span>' + svgSeparator + '<span>' + t + '</span>';
        }

        function showSlide(index) {
            slides.forEach(function (slide, i) {
                if (i === index) {
                    slide.removeAttribute('hidden');
                } else {
                    slide.setAttribute('hidden', '');
                }
            });
            if (counter) counter.innerHTML = formatCounter(index);
            current = index;
        }

        function openModal(index, sourceTrigger) {
            modal.removeAttribute('hidden');
            showSlide(index);
            activeTrigger = sourceTrigger || null;
            document.body.style.overflow = 'hidden';
            if (closeBtn) closeBtn.focus();
        }

        function closeModal() {
            modal.setAttribute('hidden', '');
            document.body.style.overflow = '';
            if (activeTrigger) {
                activeTrigger.focus();
            }
        }

        triggers.forEach(function (trigger) {
            trigger.addEventListener('click', function () {
                var parsed = parseInt(trigger.getAttribute('data-gallery-index'), 10);
                var index = Number.isNaN(parsed) ? 0 : Math.max(0, Math.min(parsed, total - 1));
                openModal(index, trigger);
            });
        });

        if (closeBtn) closeBtn.addEventListener('click', closeModal);

        if (prevBtn) {
            prevBtn.addEventListener('click', function () {
                showSlide((current - 1 + total) % total);
            });
        }

        if (nextBtn) {
            nextBtn.addEventListener('click', function () {
                showSlide((current + 1) % total);
            });
        }

        modal.addEventListener('click', function (e) {
            if (e.target === modal) closeModal();
        });

        document.addEventListener('keydown', function (e) {
            if (modal.hasAttribute('hidden')) return;
            if (e.key === 'Escape') closeModal();
            if (e.key === 'ArrowLeft') showSlide((current - 1 + total) % total);
            if (e.key === 'ArrowRight') showSlide((current + 1) % total);
        });

        var slidesContainer = modal.querySelector('.gallery-block__modal-slides');
        var swipeStartX = null;
        var swipeStartY = null;
        var swipeThreshold = 40;

        function beginSwipe(x, y) {
            swipeStartX = x;
            swipeStartY = y;
        }

        function endSwipe(x, y) {
            if (swipeStartX === null || swipeStartY === null) return;

            var dx = x - swipeStartX;
            var dy = y - swipeStartY;

            // Only react to horizontal gestures.
            if (Math.abs(dx) >= swipeThreshold && Math.abs(dx) > Math.abs(dy)) {
                if (dx < 0) {
                    showSlide((current + 1) % total);
                } else {
                    showSlide((current - 1 + total) % total);
                }
            }

            swipeStartX = null;
            swipeStartY = null;
        }

        if (slidesContainer) {
            slidesContainer.addEventListener('pointerdown', function (e) {
                if (e.pointerType === 'touch' || e.pointerType === 'pen') {
                    beginSwipe(e.clientX, e.clientY);
                }
            });

            slidesContainer.addEventListener('pointerup', function (e) {
                if (e.pointerType === 'touch' || e.pointerType === 'pen') {
                    endSwipe(e.clientX, e.clientY);
                }
            });

            // Fallback for environments that do not dispatch pointer events for touch.
            slidesContainer.addEventListener('touchstart', function (e) {
                if (!e.changedTouches || !e.changedTouches.length) return;
                beginSwipe(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            }, { passive: true });

            slidesContainer.addEventListener('touchend', function (e) {
                if (!e.changedTouches || !e.changedTouches.length) return;
                endSwipe(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
            }, { passive: true });
        }
    });
}
